module.exports = __webpack_public_path__ + "static/media/video-min.a05e6c5d.mp4";